import React, { Component } from 'react';
import ReactImageFallback from "react-image-fallback";
import PropTypes from 'prop-types';
import * as playlistReducers from "../../reducers/playlist";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as playlistActions from "../../actions/playlist";
import * as vignetsActions from "../../actions/vignets";

class VigItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            defPlClass: "ind-playlist-editor",
            activeClass: "active",
            itemClass : "ind-playlist-editor"
        };
    }


    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):


    }

    makeSelection(vignetId) {
        if(!this.props.playlistData.playlistId) {
            if(this.state.defPlClass === this.state.itemClass) {
                this.setState({itemClass: this.state.defPlClass +' '+ this.state.activeClass });
            }
            else {
                this.setState({itemClass: this.state.defPlClass });
            }

            this.props.selectVignets(vignetId);
        }


    }


    addToPlaylist(vignetId) {
        let data = {plid : this.props.playlistData.playlistId, vigids :vignetId, order:this.props.playlistData.vignetIds.length++}
        this.props.addToPlaylist(data);
    }

    render() {
        let vignet = this.props.detail;
        let vigid = vignet.vignet_id;
        let title = vignet.vignet_title;



        return (


            <div className={this.state.itemClass}  data-id={vigid} onClick={()=>this.makeSelection(vigid)}>
                <div className="play-img">
                    <ReactImageFallback
                        src={vignet.imgSrc}
                        fallbackImage={vignet.defImgSrc}
                        initialImage={vignet.defImgSrc}
                        alt="cool image should be here"
                        className="my-image" />
                </div>
                <div className="play-desc">
                    <h5 className="subheader">{title}</h5>
                    <div className="play-option">
                        <button className="add-play-button" data-id={vigid} title="Add to Playlist" onClick={()=>this.addToPlaylist(vigid)} ></button>
                        <button className="view-play-button" data-id={vigid} data-href={vignet.playerUrl} title="View"></button>
                    </div>
                </div>
            </div>

        );
    }


}

VigItem.propTypes = {
    detail: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        playlistData  :playlistReducers.getPlaylistData(state)
    };

}

export default  withRouter(connect(mapStateToProps,{
    selectVignets : vignetsActions.chooseVignets,
    addToPlaylist : playlistActions.addToPlaylist
})(VigItem));



// WEBPACK FOOTER //
// ./src/components/playlist/VigItem.js